import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';

import { DsLoggingService, ErrorSource } from '@cubigo/digital-signage';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly injector = inject(Injector);

  public handleError(error: unknown): void {
    const cause = typeof error === 'object' && error !== null && 'rejection' in error ? error.rejection : error;
    this.injector.get(DsLoggingService).logError(cause, ErrorSource.Global);
  }
}
